import { c as _c } from "react/compiler-runtime";
/**
 * @file UsersView.tsx
 * @description
 * -----------------------------------------------------
 * Componente que maneja la lógica de vista de usuarios, incluyendo
 * estados de carga, error, vacío y renderizado condicional de filtros y tabla
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-12-11
 * @author DLTCode
 * @copyright © DLTCode
 * @license Private
 * */

import React from "react";
import UsersFilters from "../components/users-filter";
import UsersTable from "../components/users-table";
import { UsersViewProvider, useUsersView } from "../users-context";
import { UsersViewProps } from "../types";
const UsersView: React.FC<UsersViewProps> = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Content />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <UsersViewProvider {...props}>{t0}</UsersViewProvider>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
const Content: React.FC = () => {
  const $ = _c(5);
  const {
    showFilters,
    showEmptyView
  } = useUsersView();
  if (showEmptyView) {
    return null;
  }
  let t0;
  if ($[0] !== showFilters) {
    t0 = showFilters && <UsersFilters />;
    $[0] = showFilters;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <UsersTable />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0) {
    t2 = <>{t0}{t1}</>;
    $[3] = t0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default UsersView;